import EdoOrganizationSummary from '../shared/EdoOrganizationSummary';
import $appSettings from 'signals/AppSettings.signal';

const EdoLenders = () => {
  const { PORTAL_TYPES } = $appSettings.value.constants;

  return (
    <EdoOrganizationSummary portalType={PORTAL_TYPES.lender} />
  );
}


export default EdoLenders;
